import { FormSchema } from '@features/executive-report/subdomains/visitation/domain/v2/form-schema';
import { SubdimensionsByName } from '@features/reports/subdomains/visitation';
import { sanitizeFormKey } from '@utils/form-keys';

export const buildDefaultValues = (
  campaignName: string,
  subdimensionsByName: SubdimensionsByName
): FormSchema => ({
  campaignName,
  salesObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  footTrafficObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  subdimensionImagesByNameAndValue: Object.entries(subdimensionsByName).reduce(
    (acc, [dimensionSlug, subdimensions]) => {
      acc[dimensionSlug] = subdimensions.reduce(
        (acc, subdimension) => {
          if (!acc) return acc;

          acc[sanitizeFormKey(subdimension.value)] = null;
          return acc;
        },
        {} as FormSchema['subdimensionImagesByNameAndValue'][string]
      );
      return acc;
    },
    {} as FormSchema['subdimensionImagesByNameAndValue']
  ),
  includedSlides: {
    intro: {
      title: true,
      agenda: true,
      howWeDoIt: true,
    },
    salesLift: {
      cover: true,
      campaignOverview: true,
      campaignOverview2: true,
      who: true,
      what: true,
      where: true,
      optimizationSummary: true,
    },
    visitLift: {
      cover: true,
      overview: true,
      who: true,
      what: true,
      where: true,
    },
    campaignInsights: {
      cover: true,
      audienceProfile: true,
      demographicProfile: true,
      topLocations: true,
      moreStats: true,
      visitorProfile: true,
    },
  },
  youtubeImpressions: null,
});
